// Parallax scroll effect
// Add data-parallax to an .oi-aspect-img (its .oi-aspect container needs
// overflow: hidden so the shifted image doesn't bleed outside its bounds).
// Add data-parallax-speed="0.2" to adjust intensity (default 0.15).

const parallaxEls = document.querySelectorAll('[data-parallax]');

// Must match the scale() applied alongside translateY(--parallax-y) in
// _main.scss — it sets how much overscan is available to pan within before
// the image's edge would be exposed.
const SCALE = 1.15;

if (parallaxEls.length) {
    let ticking = false;

    function updateParallax() {
        const viewportHeight = window.innerHeight;

        parallaxEls.forEach(function (el) {
            const speed = parseFloat(el.dataset.parallaxSpeed) || 0.15;
            const rect = el.parentElement.getBoundingClientRect();
            const rawOffset = (rect.top - (viewportHeight - rect.height) / 2) * speed;
            // Clamp so the pan never exceeds the overscan the scale() buys us.
            const maxOffset = (rect.height * (SCALE - 1)) / 2;
            const offset = Math.max(-maxOffset, Math.min(maxOffset, rawOffset));
            el.style.setProperty('--parallax-y', offset + 'px');
        });

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
        }
    }

    updateParallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
}
